module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": true
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.limpiarEmpleado
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Módulo")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroModulo),
      expression: "filtroModulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.filtroModulo)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaModulo = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroModulo = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaModulo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.limpiarModulo
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaModulo) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-actividades-modulo', {
    attrs: {
      "codigo": _vm.filtroModulo
    },
    on: {
      "selected": _vm.seleccionarModulo,
      "close": function($event) {
        _vm.mostrarBusquedaModulo = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Acciones")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroAccion),
      expression: "filtroAccion"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.filtroAccion)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaAccion = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroAccion = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaAccion = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.limpiarAccion
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaAccion) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-actividades-acciones', {
    attrs: {
      "codigo": _vm.filtroAccion
    },
    on: {
      "selected": _vm.seleccionarAccion,
      "close": function($event) {
        _vm.mostrarBusquedaAccion = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Desde")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desde),
      expression: "desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.desde)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desde = $event.target.value
      }
    }
  })])])])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "lookup"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Hasta")]), _c('div', {
    staticClass: "input-container display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasta),
      expression: "hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.hasta)
    },
    on: {
      "blur": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hasta = $event.target.value
      }
    }
  })])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "is-desktop",
    staticClass: "is-desktop"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Perfil")]), _c('th', [_vm._v("Módulo")]), _c('th', [_vm._v("Datos")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "hint--top inline",
      attrs: {
        "aria-label": 'log: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion || o.accion) + " ")]), _c('span', {
      staticClass: "hint--top has-text-bold",
      attrs: {
        "aria-label": o.fechaString
      }
    }, [_vm._v(_vm._s(_vm._f("fromNow")(o.fecha)))])]), _c('td', [_vm._v(_vm._s(_vm._f("capitalize")(o.perfil || o.usuario)))]), _c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID relacionado: ' + o.idRelacionado
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(o.modulo)))])]), _c('td', [_c('div', [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Accion: ")]), _c('span', {
      staticClass: "hint--top tipo-icon",
      attrs: {
        "aria-label": o.tipo
      }
    }, [_c('i', {
      class: _vm.tipoIcon[o.tipo]
    })])]), _vm._l((o.datos), function(value, key) {
      return _c('div', [_c('span', {
        staticClass: "has-text-bold"
      }, [_vm._v(_vm._s(_vm._f("capitalize")(key)) + ": ")]), _c('span', [_vm._v(_vm._s(value))])])
    })], 2)])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "is-mobile",
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "status"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(o.perfil || o.usuario)))])]), _c('div', {
      staticClass: "perfil"
    }), _c('div', {
      staticClass: "descripcion-tipo hint--top",
      attrs: {
        "aria-label": 'ID relacionado: ' + o.idRelacionado
      }
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v(_vm._s(o.modulo.toUpperCase()))])]), _c('div', {
      staticClass: "motivo hint--bottom",
      attrs: {
        "aria-label": 'Log: ' + o.id
      }
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v(_vm._s(o.descripcion || o.accion) + " " + _vm._s(_vm._f("fromNow")(o.fecha)))]), _c('div', {
      staticClass: "has-text-lef datos-auditoria"
    }, [_c('div', [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Accion: ")]), _c('span', {
      staticClass: "hint--top tipo-icon",
      attrs: {
        "aria-label": o.tipo
      }
    }, [_c('i', {
      class: _vm.tipoIcon[o.tipo]
    })])]), _vm._l((o.datos), function(value, key) {
      return _c('div', [_c('span', {
        staticClass: "has-text-bold"
      }, [_vm._v(_vm._s(_vm._f("capitalize")(key)) + ": ")]), _c('span', [_vm._v(_vm._s(value))])])
    })], 2), _c('div', {
      staticClass: "fecha"
    }, [_vm._v(_vm._s(o.fechaString))])])])
  }), 0)])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Auditoria")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6d6427e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Auditoria.vue
// module id = 859
// module chunks = 0